import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Outlet } from 'react-router-dom'

import { Header } from '@components/header'
import { ProfileNavMenu } from '@components/profile_nav/profile_nav'
import { useLocationSetup } from 'hooks/use_location_setup'
import { useMonitoringData } from 'hooks/use_monitoring_data'

export const ProfileLayout = () => {
  const theme = useTheme()

  useLocationSetup()
  useMonitoringData()

  const isBelowMD = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <>
      <Header />
      {isBelowMD ? (
        <Box width="100%" margin="40px auto">
          <Outlet />
        </Box>
      ) : (
        <Box width="100%" maxWidth="1000px" margin="40px auto">
          <Stack direction="row" spacing={3}>
            <ProfileNavMenu />
            <Outlet />
          </Stack>
        </Box>
      )}
    </>
  )
}
